import React from "react";
import CodeMirror from "@uiw/react-codemirror";
import { EditorView } from "@codemirror/view";
import { getCodeMirrorExtensions } from "../../utils/languageMap";
import { oneDark } from "@codemirror/theme-one-dark";

const CodeEditor = ({
  language,
  code,
  setCode,
  darkTheme,
  editable = true,
  isUIMode = false,
  onCodeChange = null,
}) => {
  const extensions = [
    ...getCodeMirrorExtensions(language),
    ...(!darkTheme
      ? [
          EditorView.theme({
            "&": { backgroundColor: "#FFFFFF" },
            ".cm-gutters": {
              backgroundColor: "#F6F4FA",
              color: "#7B8094",
              borderRight: "1px solid #ECE8F4",
            },
            ".cm-activeLine": { backgroundColor: "#F6F3FC" },
            ".cm-activeLineGutter": {
              backgroundColor: "#F0EBFA",
              color: "#191F2D",
            },
            ".cm-content": { caretColor: "#4B1498" },
            "&.cm-focused .cm-cursor": { borderLeftColor: "#4B1498" },
            "&.cm-focused .cm-selectionBackground, ::selection": {
              backgroundColor: "rgba(166,111,255,.24)",
            },
          }, { dark: false }),
        ]
      : []),
  ];

  const handleChange = (value) => {
    if (!editable) return;

    if (isUIMode && onCodeChange) {
      // For UI mode, call the specialized handler
      onCodeChange(value);
    } else {
      // For regular mode, use setCode
      setCode(value);
    }
  };

  return (
    <div className="h-full min-h-0 rounded-lg overflow-hidden border border-[#E7E1F4] dark:border-gray-700 scroollbar-thin">
      <CodeMirror
        value={code}
        height="100%"
        theme={darkTheme ? oneDark : "light"}
        extensions={extensions}
        basicSetup={{
          lineNumbers: true,
          highlightActiveLine: true,
          highlightActiveLineGutter: true,
          foldGutter: true,
          dropCursor: true,
        }}
        editable={editable}
        onChange={handleChange}
        className="h-full font-mono text-sm"
      />
    </div>
  );
};

export default CodeEditor;
